import React, { FC } from "react";
import { Grid } from "@mui/material";
import { useDynamicPageContent } from "hooks/useDynamicPageContent";
import { DynamicViewContent } from "components";

export const IntegrityView: FC = () => {
  const { pageContent, pageHTMLContent } = useDynamicPageContent({ pageType: "integrity" });

  return (
    <Grid container position="relative">
      <DynamicViewContent pageContent={pageContent} pageHTMLContent={pageHTMLContent} />
    </Grid>
  );
};
